import { render, staticRenderFns } from "./language-texts.vue?vue&type=template&id=a8f9efec&scoped=true&"
import script from "./language-texts.vue?vue&type=script&lang=js&"
export * from "./language-texts.vue?vue&type=script&lang=js&"
import style0 from "./language-texts.vue?vue&type=style&index=0&id=a8f9efec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f9efec",
  null
  
)

export default component.exports